/// <reference path="type.type.ts" />

import AxelType from './type.type';

export default class AxelString extends AxelType {
  constructor(value) {
    super(value);

    const computedValue = String(value);

    if ('string' === typeof value || 'number' === typeof value) {
      this._newValue = computedValue;
    } else {
      this.setAsDirty();
    }
  }
}
